import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/participants/new',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ParticipantNewContainer',
      './modules/participantNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ParticipantNew = require('./containers/ParticipantNewContainer').default
      const actions = require('./modules/participantNew')
      const reducer = require('./modules/participantNew').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'participantNew', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ParticipantNew)

    /* Webpack named bundle   */
    }, 'participantNew')
  }
})




// WEBPACK FOOTER //
// ./src/routes/ParticipantNew/index.js